var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data)?_c('Tag',{staticClass:"click noborder",nativeOn:{"click":function($event){return _vm.show.apply(null, arguments)}}},[_vm._v("附件")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }